module.exports = __webpack_public_path__ + "static/media/ic_discover.fd226b38.svg";